import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import miLogo from '../assets/mi-logo.png'; 

// 🔥 ESCUDO ANTI-CRASH: Si un dato viene vacío o undefined, le pone '---' en vez de romper el PDF
const safeText = (text) => {
    if (text === null || text === undefined) return '---';
    const str = String(text).trim();
    return str === '' ? '---' : str;
};

const styles = StyleSheet.create({
    page: { fontFamily: 'Helvetica', fontSize: 10, padding: 30, color: '#333' },
    header: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, paddingBottom: 15, borderBottomWidth: 2, borderBottomColor: '#18BC9C' },
    companyInfo: { width: '60%' },
    title: { fontSize: 18, fontWeight: 'bold', color: '#2C3E50', marginBottom: 4 },
    subtitle: { fontSize: 10, color: '#555', textTransform: 'uppercase', letterSpacing: 1 },
    logoContainer: { width: '40%', alignItems: 'flex-end' },
    logo: { width: 80 },
    
    table: { display: 'table', width: 'auto', borderStyle: 'solid', borderWidth: 0 },
    tableRowHeader: { flexDirection: 'row', backgroundColor: '#18BC9C', borderBottomWidth: 1, borderBottomColor: '#16a085' },
    tableRow: { flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: '#eaeaea', paddingVertical: 6, alignItems: 'center' },
    
    tableColHeader1: { width: '30%', padding: 8 },
    tableColHeader2: { width: '35%', padding: 8 },
    tableColHeader3: { width: '35%', padding: 8 },
    
    tableCol1: { width: '30%', paddingHorizontal: 8 },
    tableCol2: { width: '35%', paddingHorizontal: 8 },
    tableCol3: { width: '35%', paddingHorizontal: 8 },
    
    tableCellHeader: { fontSize: 10, fontWeight: 'bold', color: 'white', textTransform: 'uppercase' },
    tableCell: { fontSize: 9, lineHeight: 1.4, color: '#555' },
    textBold: { fontSize: 10, fontWeight: 'bold', color: '#2C3E50', marginBottom: 2 },
    
    footer: { position: 'absolute', bottom: 30, left: 30, right: 30, flexDirection: 'row', justifyContent: 'space-between', borderTopWidth: 1, borderTopColor: '#eaeaea', paddingTop: 10 },
    footerText: { fontSize: 8, color: '#888', fontWeight: 'bold' }
});

const ClientesPDF = ({ clientes }) => (
    <Document>
        <Page size="A4" style={styles.page}>
            <View style={styles.header}>
                <View style={styles.companyInfo}>
                    <Text style={styles.title}>BASE DE DATOS DE CLIENTES</Text>
                    <Text style={styles.subtitle}>Scarjav SL</Text>
                </View>
                <View style={styles.logoContainer}>
                    {miLogo && <Image style={styles.logo} src={miLogo} />}
                </View>
            </View>

            <View style={styles.table}>
                <View style={styles.tableRowHeader} fixed>
                    <View style={styles.tableColHeader1}><Text style={styles.tableCellHeader}>Cliente / Entidad</Text></View>
                    <View style={styles.tableColHeader2}><Text style={styles.tableCellHeader}>Contacto Principal</Text></View>
                    <View style={styles.tableColHeader3}><Text style={styles.tableCellHeader}>Ubicación</Text></View>
                </View>

                {clientes.map((cliente, i) => {
                    // Verificamos si hay contactos, si no, devolvemos un objeto vacío para evitar errores
                    const contacto = cliente.personasContacto && cliente.personasContacto.length > 0 ? cliente.personasContacto[0] : {};
                    
                    return (
                        <View style={styles.tableRow} key={cliente.id || i} wrap={false}>
                            <View style={styles.tableCol1}>
                                <Text style={styles.textBold}>{safeText(cliente.name)}</Text>
                                <Text style={styles.tableCell}>NIF: {safeText(cliente.nif)}</Text>
                            </View>
                            <View style={styles.tableCol2}>
                                {/* Usamos el escudo safeText en ABSOLUTAMENTE TODOS los campos */}
                                <Text style={styles.textBold}>{safeText(contacto.nombre || 'Sin contacto')}</Text>
                                <Text style={styles.tableCell}>{safeText(contacto.telefono)}</Text>
                                <Text style={styles.tableCell}>{safeText(contacto.email)}</Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBold}>{safeText(cliente.poblacion)}</Text>
                                <Text style={styles.tableCell}>{safeText(cliente.direccion)}</Text>
                                <Text style={styles.tableCell}>CP: {safeText(cliente.codPostal)}</Text>
                            </View>
                        </View>
                    );
                })}
            </View>

            <View style={styles.footer} fixed>
                {/* Aseguramos que el total sea un String para que no crashee */}
                <Text style={styles.footerText}>Total de Registros: {String(clientes.length)}</Text>
                <Text style={styles.footerText}>Generado el: {new Date().toLocaleDateString('es-ES')}</Text>
            </View>
        </Page>
    </Document>
);

export default ClientesPDF;